import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWallet2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM5 8C5 7.44772 5.44772 7 6 7H18C18.5523 7 19 7.44772 19 8V10H16.1716L14.1716 12H9.82843L7.82843 10H5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet2;
